import images from "../constants/images";
import { NavLink } from "react-router-dom";

const BottomTab = () => {
    return (
        <div className="bottom-tab">
            <div className="bottom">
                <NavLink className="style-7" to="/attendance">
                    <img src={images.attendance} className="bottom-icon" />
                    <span className="style-10">Attendance</span>
                    <div className="style-11" />
                </NavLink>

                <NavLink className="style-7" to="/employees">
                    <img src={images.user} className="bottom-icon" />
                    <span className="style-10">Employees</span>
                    <div className="style-11" />
                </NavLink>

                <NavLink className="style-7" to="/machines">
                    <img src={images.machine} className="bottom-icon" />
                    <span className="style-10">Machines</span>
                    <div className="style-11" />
                </NavLink>
            </div>
        </div>
    );
};

export default BottomTab;
